module.exports = __webpack_public_path__ + "static/img/memberZJF.ca9279a.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investTeam/memberZJF.png
// module id = DOSe
// module chunks = 0